// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3gdeJ","paramInput":"JobSimulator_paramInput__1pR79","input":"JobSimulator_input__3xga0"};